import React from "react";
import { useSelector } from "react-redux";
import { normalizersSelector } from "../../../services/Normalizers/selectors";
import "./NormalizersReadme.scss";

export const NormalizersReadme = ({ normalizer }) => {
    const { normalizers } = useSelector(normalizersSelector);
    const normalizerData = normalizers[normalizer.code];

    return (
        <div className={"normalizers-readme"}>
            <div className={"normalizers-readme__item"}>
                <div dangerouslySetInnerHTML={{ __html: (normalizer?.description || normalizerData?.description) }} />
            </div>
        </div>
    );
};
